import { styled } from '@mui/material/styles';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { BlockContent } from 'src/components/upload';

const DropZoneStyle = styled('div')(({ theme }) => ({
  outline: 'none',
  overflow: 'hidden',
  position: 'relative',
  padding: theme.spacing(5, 1),
  borderRadius: theme.shape.borderRadius,
  transition: theme.transitions.create('padding'),
  backgroundColor: theme.palette.background.neutral,
  border: `1px dashed ${theme.palette.grey[500_32]}`,
  '&:hover': { opacity: 0.72, cursor: 'pointer' },
}));

type UploadFileProps = DropzoneOptions;

export function UploadFile({ ...other }: UploadFileProps) {
  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    ...other,
  });

  return (
    <DropZoneStyle
      {...getRootProps()}
      sx={{
        ...(isDragActive && { opacity: 0.72 }),
        ...((isDragReject) && {
          color: 'error.main',
          borderColor: 'error.light',
          bgcolor: 'error.lighter',
        })
      }}
    >
      <input {...getInputProps()} />
      <BlockContent />
    </DropZoneStyle>
  );
}